import md5 from 'md5';
import Pauschalenart from './pauschalenart';

export default class Pauschale {
    constructor(
        id, 
        pauschalenart = '', 
        name = '', 
        monat = '', 
        jahr = '',
        summe = 0, 
        bemerkung = '',
        datum = '',
        uhrzeit = {
            start: '',
            ende: ''
        }
    ){
        this.id = id || md5(Date.now());
        this.pauschalenart = pauschalenart instanceof Pauschalenart ? pauschalenart.id : pauschalenart;
        this.name = name;
        this.monat = monat;
        this.jahr = jahr || new Date().getFullYear();
        this.summe = parseFloat(summe).toFixed(2);
        this.bemerkung = bemerkung || '';
        this.datum = datum || '';
        this.uhrzeit = Object.assign({
            start: '',
            ende: ''
        }, uhrzeit);
    }

    toFirestore(){
        return {
            id: this.id || '',
            pauschalenart: this.pauschalenart instanceof Pauschalenart ? this.pauschalenart.id : this.pauschalenart || '',
            name: this.name || '',
            monat: this.monat || '',
            jahr: this.jahr || new Date().getFullYear(),
            summe: this.summe ? parseFloat(this.summe).toFixed(2) : 0,
            bemerkung: this.bemerkung || '',
            datum: this.datum || '',
            uhrzeit: Object.assign({
                von: '',
                bis: ''
            }, this.uhrzeit)
        }
    }
}